import { i18nGridLocalText } from '@/utils/agGrid'
import { isNumber, toSimulateRefreshingListBackingTo } from '@/utils'
import Logger from '@/class/log'
import { DocumentManage } from '@/utils/commonUtil'

// 无需附加默认ID的元素
const ignoreDefaultIdItems = ['ElOption', 'ElDropdownItem', 'ElBadge', 'ElRow', 'ElCol', 'ElForm', 'ElFormItem']
// // 同名id计数map
// const idNumMap = new Map()
// // 重复id集合
// const repeatIdSet = new Set()
// 添加ID的模块
const rountArr = ['SeaBooking', 'SiBooking', 'AeBooking', 'AiBooking', 'ReBooking',
  'PriceReal', 'PriceFCLReal', 'PriceFCL', 'Quotation', 'SurchargeFCL', 'PriceFCLExtra', 'PriceLCLReal', 'PriceAirReal',
  'ShippingSchedule', 'PriceFCLStat', 'PriceFCLLog', 'PriceAir', 'PriceFclAddon', 'QuotationFcl', 'PriceFCLShare', 'PriceWeightLimit',
  'PriceLCL', 'QuotationClient', 'QuotationAir', 'PriceFCLSubscribe', 'QuotationLcl', 'PODCharge', 'PriceAirShare', 'PriceAirSubscribe',
  'PriceLCLShare', 'PriceAirStat', 'PriceAirLog', 'Partner', 'SiPrediction', 'AiOrder', 'MakeInvoice', 'BillPayment', 'WriteOff', 'FinanceChargeSearch',
  'BillingNative', 'ImportCharge', 'BookingVerify', 'IntelligentBooking', 'Edi', 'SalesQuery', 'RemoteBooking', 'FinanceManage', 'AnalysisDetails',
  'VoucherMaintenance', 'SEWarehousing', 'IEBooking', 'AeRouteCentral', 'FBABookingNew', 'FBAAeBooking', 'FBARailwayExport', 'FmSingleRelease',
  'DocumentCirculation', 'AccountingDocumentSearch', 'RailwayStation', 'ContractManagement', 'AirPort', 'ClRealSendReceive', 'BasicData', 'RateManagement',
  'PayService', 'CostPlan', 'SeaPort', 'AeRouteCentral', 'AccountingDocument', 'MyCustomer', 'MyGroupCustomer', 'ShareCustomer', 'CRMScheduleCustomerManager', 'CRMRecoveryCustomerManager',
  'EventManager', 'CreditBusinessManage', 'FmRailwayBoxTube', 'Project', 'AccountingDocumentSearch', 'AccountBook', 'AccountingClosing', 'DocumentCirculation',
  'BillOverseasSCenter', 'BillPaymentJc', 'ChangeChargeVerify', 'Document', 'SEBatchUploadFile', 'SIBatchUploadFile', 'AEBatchUploadFile', 'AIBatchUploadFile',
  'IEBatchUploadFile', 'Vessel', 'AEWarehousing', 'AePrepareDocument', 'AeMawb', 'AECustomsInventory', 'ReleaseManagement', 'FinancialReport']
// 需要移除ID前列拼接名称的字段
const removeArr = ['StartMakeInvoice']
/**
 * 生成ID
 * @param {Vue} vm
 * @returns
 */
function generateId(vm) {
  const names = []
  for (let item = vm; item; item = item.$parent) {
    if (!item.$options.name) {
      continue
    }
    names.push(item.$options.name + getNo(item))
    if (item.$options.name === vm.$route.name) {
      const query = vm.$route.query
      if (query.openNew && query.key) {
        names.push(query.key)
      }
      break
    }
  }
  let id = names.reverse().join('')
  for (const item of removeArr) {
    if (id.indexOf(item) > 0) {
      id = id.replace(item, '')
    }
  }
  return id
}

/**
 * 获取no属性
 * @param {Vue} vm
 */
function getNo(vm) {
  if (vm.$el && vm.$el.getAttribute) {
    let no = vm.$el.getAttribute('no')
    if (!no && (!vm.$children || vm.$children.length === 0)) {
      const firstChild = vm.$el.firstElementChild
      if (firstChild && firstChild.getAttribute) {
        no = firstChild.getAttribute('no')
      }
    }
    if (no) {
      return no
    }
  }
  return ''
}

export default {
  // watch: {
  //   $route() {
  //     this.$nextTick(() => {
  //       if (this.$options.name === 'App') {
  //         if (this.$route.name === 'Dashboard') {
  //           console.log('App')
  //           console.log([...repeatIdSet].filter(p => p.startsWith('App')).join('\n'))
  //         } else {
  //           let prefix = this.$route.name
  //           const query = this.$route.query
  //           if (query.openNew && query.key) {
  //             prefix = query.key + prefix
  //           }
  //           console.log(prefix)
  //           console.log([...repeatIdSet].filter(p => p.startsWith(prefix)).join('\n'))
  //         }
  //       }
  //     })
  //   }
  // },
  beforeCreate() {
    // todo 只混入本项目的组件
    if (this.$root && (this.$options.name && !this.$options.name.startsWith('El'))) {
      this.$logger = new Logger(this)
    }
  },
  mounted() {
    this._setDefaultId()
    // // 如果含html元素且需要默认ID，则执行以下代码
    // if (this.$el && this.$el.getAttribute && !ignoreDefaultIdItems.includes(this.$options.name)) {
    //   const id = this.$el.getAttribute('id')
    //   if (id && (id.startsWith('SeaBooking') || id.startsWith('SiBooking') || id.startsWith('AeBooking') || id.startsWith('AiBooking') || id.startsWith('ReBooking'))) { // 目前仅针对海运订舱极速版、海运操作、空运订舱、空运操作、铁路操作模块附加默认ID
    //     let num = idNumMap.get(id)
    //     if (num) {
    //       idNumMap.set(id, ++num)
    //       repeatIdSet.add(id)
    //     } else {
    //       idNumMap.set(id, 1)
    //     }
    //   }
    // }
  },
  updated() {
    this._setDefaultId()
  },
  beforeDestroy() {
    // // 如果含html元素且需要默认ID，则执行以下代码
    // if (this.$el && this.$el.getAttribute && !ignoreDefaultIdItems.includes(this.$options.name)) {
    //   const id = this.$el.getAttribute('id')
    //   if (id) {
    //     let num = idNumMap.get(id)
    //     if (num) {
    //       num -= 1
    //       if (num <= 0) {
    //         idNumMap.delete(id)
    //         repeatIdSet.delete(id)
    //       } else {
    //         idNumMap.set(id, num)
    //         if (num === 1) {
    //           repeatIdSet.delete(id)
    //         }
    //       }
    //     }
    //   }
    // }
    if (this.$root && (this.$options.name && !this.$options.name.startsWith('El'))) {
      try {
        /*
        DocumentManage里的变量是全局的，不把引用移除，组件占用的内存就不会释放。
        这里统一调用DocumentManage.destory，防止有遗漏。
        */
        if (this.documentManage instanceof DocumentManage) {
          setTimeout(documentManage => { documentManage.destory() }, 0, this.documentManage)
        }
        if (this.doc instanceof DocumentManage) {
          setTimeout(doc => { doc.destory() }, 0, this.doc)
        }
        /* 组件销毁时，手动强制移除所有事件监听、解除组件引用、解除Vue观察者绑定(Watchers)的代码 */
        this.$off()
        this.$el.__vue__ = null
        this._watchers.forEach(watcher => watcher.teardown())
      } catch (e) {
        this.$logger.log(e)
      }
      this.$logger.destroy()
    }
  },
  methods: {
    _i18nGridLocalText(key, defaultValue) {
      return i18nGridLocalText(key, defaultValue)
    },
    _isNumber(val) {
      return isNumber(val)
    },
    _toSimulateRefreshingListBackingTo: toSimulateRefreshingListBackingTo,
    _setDefaultId() {
      // 如果含html元素且需要默认ID，则执行以下代码
      if (this.$el && this.$el.getAttribute && !ignoreDefaultIdItems.includes(this.$options.name) && this.$route) {
        let id = this.$el.getAttribute('id')
        if (!id) {
          id = generateId(this)
          // if (id && (id.startsWith('SeaBooking') || id.startsWith('SiBooking') || id.startsWith('AeBooking') || id.startsWith('AiBooking') || id.startsWith('ReBooking'))) { // 目前仅针对海运订舱极速版、海运操作、空运订舱、空运操作、铁路操作模块附加默认ID
          //   this.$el.setAttribute('id', id)
          // }
          if (id) {
            let isExist = false
            const query = this.$route.query
            const key = (query.openNew && query.key) ? query.key : ''
            for (const rount of rountArr) {
              if (id.startsWith(key + rount)) {
                isExist = true
                break
              }
            }
            if (isExist) {
              this.$el.setAttribute('id', id)
            }
          }
        }
      }
    }
  }
}
